// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/9cc54c0b14c9a22b8aff.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"a4463db6b6eaa27e86d3","122":"51c1b851ff356722433a","123":"21114a9d2d03990f04a5"}[chunkId] + ".chunk.js";
};